import React, { Component } from 'react';
import TheChangeSlider from './TheChangeSlider';

class TheChange extends Component {

  render() {
    return (
      <section id="the-change-section">
        <div className="container">
          <div className="row">
            <div className="col12">
              <h2>Be The Change.</h2>
            </div>
          </div>
          <div className="row leadtheway-flex">
            <div className="copy-col">
              <p>Be the change you wish to see in the world. It’s about knowing what matters to you and understanding the choices and decisions you make now can impact your future. Here are some small actions you can use to inspire others to be positive influences.</p>
            </div>
            <div className="copy-col">

            </div>
          </div>
          <div className="row">
            <div className="slider">
              <TheChangeSlider />
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default TheChange;



// WEBPACK FOOTER //
// ./src/components/TheChange/TheChange.js